export default __webpack_public_path__ + "static/media/shelterTech.c43b635a.mp4";